<template>
  <div class="orderListFilter">
      <div class="filterHeader">
          <template v-for="(filter, index) in filterbtns">
            <button 
                @click="togglestatus(filter)"
                :key="index"
                :class="['btn', {'btn-outline-primary' : !filter.isactive},  {'btn-primary' : filter.isactive}]">
                {{filter.label == 'assign' ? 'Pending' : filter.label}}
            </button>
          </template>
      </div>

        <search-component
            @searching="(e) => searchtext = e.toLowerCase()" 
            searchClass="orderFilterSearch"
            placeholder="Search employees"
            />

        <div class="orderEmployeesList">
            <template v-for="driver in driverlist">
                <div 
                    v-if="driver.name.toLowerCase().search(searchtext) >= 0"
                    :key="driver.id" 
                    :class="[
                        {'unfiltered' : !filtered.includes(driver.id)},
                        {'active' : filtered.includes(driver.id)}
                    ]"
                    class="orderEmployee">

                    <template v-if="driver.avatar_url">
                        <span 
                            :style="`background-image : url(${driver.avatar_url});`"
                            class="employeeImage">
                        </span>
                    </template>

                    <template v-else>
                        <span 
                            class="employeeImage noavatar">
                            <b-icon icon="person"></b-icon>
                        </span>
                    </template>


                    <span class="employeeName">
                        {{driver.name}}
                    </span>

                    <span  
                        @click="toggleFilter(driver.id)"
                        class="orderStatus">
                        <b-icon icon="check"></b-icon>
                    </span>
                </div>
            </template>
        </div>
  </div>
</template>

<script>
/**
 * Declerations
 */

// Plugins
import moment from 'moment'

// Helpers
import Helper from '@/helpers/helper'

// components
import searchComponent from '@/components/searchComponent.vue';

export default {
    props : {
        orderlist : {
            type : Array,
            default : () => []
        },
        filtered : {
            type : Array,
            default : () => []
        },
        filteredstatus : {
            type : Array,
            default : () => []
        }
    },
    components : {
        'search-component' : searchComponent
    },
    data() {
        return {
            searchtext : '',
            filterbtns : [
                {
                    label : 'assign',
                    isactive : true
                },
                {
                    label : 'accepted',
                    isactive : true
                },
                {
                    label : 'delivered',
                    isactive : true
                }
            ],
        }
    },
    computed : {
        /**
         * Driver list
         */
        driverlist() {
            return this.$store.state.employees.filter(em => em.roles.includes('driver'))
        },
         /**
         * Driver list with orders
         * Filter orders should be today and future
         * group order by drivers / employee
         */
        drivergrouporders() {
            return this.orderlist.filter(order => moment(order.delivery_date).utc().isSameOrAfter(moment().endOf('day'), 'day') ).filter((value, index, self) => index == self.findIndex(t => t.assign_to.id == value.assign_to.id))
        },
    },
    filters : {
        /**
         * Format date by 
         * @param format
         */
        formatdate(date, format) {
            return date ? moment(date).format(format) : ''
        },
        /**
         * Format date by relation like
         * Today, Tomorrow, and MM/DD/YYYY
         */
        formatreldate(date) {
            return Helper.datestring(date)
        }
    },
    methods : {
        /**
         * Toggle filter status
         */
        togglestatus(filter) {
            filter.isactive = !filter.isactive
            let filteres = this.filterbtns.filter(fil => fil.isactive).map(fil => fil.label)

            /**
             * Check if toggle amend status
             */
            if(filteres.includes('accepted')) {
                filteres = [...filteres , 'amend']
            } 

            this.$emit('update:filteredstatus', filteres)
        },
        /**
         * Toggle filter driver
         */
        toggleFilter(driverid) {
            console.log('testin', driverid)
            if(this.filtered.includes(driverid)) {
                this.$emit('update:filtered', this.filtered.filter(d => d != driverid))
            } else {
                this.$emit('update:filtered', [...this.filtered, driverid])
            }
        },
        /**
         * Group order boxes and flavors
         */
        grouporderbox(orders) {
            const orderlist = Object.values(orders);

            const group = this.groupboxorder(orderlist)

            return group
        }
    },
    /**
     * run function before component render
     */
    beforeMount() {
        this.filterbtns = this.filterbtns.map(f => {
            f.isactive = this.filteredstatus.includes(f.label)
            return f
        })
    }
}
</script>

<style lang="scss">
@import '@/scss/partials/_colors.scss';
@import '@/scss/partials/_mixins.scss';

.orderListFilter {

    .filterHeader {
        padding-top   : 15px;
        padding-bottom: 15px;
        display: flex;

        .btn {
            flex          : 1;
            height        : 35px;
            padding       : 0;
            font-size     : 13px;
            letter-spacing: 1px;

            &:nth-child(2) {
                margin-left : 10px;
                margin-right: 10px;
            }

            &.btn-outline-primary {
                &:focus {
                    background-color: transparent;
                    border-color    : $grey;
                    color           : $black;
                }
            }
        }
    }

    .orderEmployeesList {
        padding-top  : 30px;
        padding-left : 15px;
        padding-right: 15px;
    
        .orderEmployee {
            display      : flex;
            align-items  : center;
            margin-bottom: 30px;

            &.unfiltered {
                opacity: 0.5;

                
            }

            &.active {
                .orderStatus {
                    background-color: $primaryColor;
                    color           : white;
                    border-color    : transparent;
                }
            }


            .employeeImage {
                width              : 50px;
                height             : 50px;
                display            : block;
                border-radius      : 100%;
                background-size    : cover;
                background-position: center;

                &.noavatar {
                    border         : 1px solid $grey;
                    display        : flex;
                    align-items    : center;
                    justify-content: center;

                    .b-icon.bi {
                        font-size : 25px;
                    }
                }
            }

            .employeeName {
                padding-left: 15px;
                font-size   : 20px;
                font-weight : 700;
            }

            .orderStatus {
                margin-left     : auto;
                margin-right    : 0;
                width           : 40px;
                height          : 40px;
                border-radius   : 100%;
                cursor          : pointer;
                display         : flex;
                align-items     : center;
                justify-content : center;
                font-size       : 25px;
                background-color: transparent;
                color           : $grey;
                border          : 1px solid $grey;
            }
        }
    }
}
</style>